"use strict";

require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.includes.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "backgroundSize", {
  enumerable: true,
  get: function get() {
    return backgroundSize;
  }
});
var _dataTypes = require("./dataTypes");
var _splitAtTopLevelOnly = require("./splitAtTopLevelOnly");
function backgroundSize(value) {
  var keywordValues = ["cover", "contain"];
  // the <length-percentage> type will probably be a css function
  // so we have to use `splitAtTopLevelOnly`
  return (0, _splitAtTopLevelOnly.splitAtTopLevelOnly)(value, ",").every(function (part) {
    var sizes = (0, _splitAtTopLevelOnly.splitAtTopLevelOnly)(part, "_").filter(Boolean);
    if (sizes.length === 1 && keywordValues.includes(sizes[0])) return true;
    if (sizes.length !== 1 && sizes.length !== 2) return false;
    return sizes.every(function (size) {
      return (0, _dataTypes.length)(size) || (0, _dataTypes.percentage)(size) || size === "auto";
    });
  });
}